import React from 'react'

import './AvailabilityLoader.scss'
import Loader from 'components/Loader'

const AvailabilityLoader = () => {
  return (
    <Loader
      text='Buscando disponibilidad'
      className='AvailabilityLoader'
      />
  )
}

AvailabilityLoader.displayName = 'AvailabilityLoader'

export default AvailabilityLoader



// WEBPACK FOOTER //
// ./src/screens/App/shared/components/AvailabilityLoader/AvailabilityLoader.js